import { logExportPptFeature } from "./common";

export function getTablePptExport(data: string, columnWidth: number[]): any {
  const dataArray: any[] = [];
  data.split("\n").forEach((dataRow: any) => {
    dataArray.push(dataRow.split("¤"));
  });

  const rows = buildExportData(
    buildRows(dataArray.slice(1, 11)),
    buildHeader(dataArray[0])
  );
  const tabOpts = {
    colW: columnWidth,
    fontSize: 8,
    fontFace: "Roboto",
  };
  logExportPptFeature();

  return {
    type: "table",
    data: rows,
    options: tabOpts,
  };
}

function buildExportData(data: any[], headers: any[]): any[] {
  return [headers].concat(data);
}

function buildHeader(header: any[]): any[] {
  return header.map((headerValue: any) => {
    return {
      text: headerValue,
      options: {
        align: "left",
        bold: true,
        border: { color: "e2e2e2" },
      },
    };
  });
}

function buildRows(data: any[]): any[] {
  return data.map((dataRow: string[], index) => {
    return dataRow.map((element: any) => {
      if (isNaN(element.replace(/,/g, "")) && element.trim() !== "--") {
        return {
          text: element,
          options: {
            align: "left",
            border: { type: "none" },
            fill: index % 2 === 1 ? "f5f6f7" : "",
          },
        };
      } else {
        return {
          text: element,
          options: {
            align: "right",
            border: { type: "none" },
            fill: index % 2 === 1 ? "f5f6f7" : "",
          },
        };
      }
    });
  });
}
